import {
  ELEMENT_ATTRIBUTE_GROUP,
  ELEMENT_GROUPS
} from '../../../../AppDesigner/Elements';

const fields = {
  group: ELEMENT_GROUPS.TEXT,
  name: 'ChartSection',
  label: 'Network Diagram Chart Section',
  icon: 'DocumentTextIcon',
  description: 'Displays a network diagram from supplied data',
  properties: [
    {
      label: 'Data Link Name',
      name: 'dataLinkName',
      default: 'pim',
      description:
        'Choose a Data Link assigned to this page that the chart will get its data from.',
      editor: 'textbox',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    }
  ]
};

export default fields;
